import { tv } from "../foundations/cn.js";
import { FOCUS_RING, PRESS, PRESS_SCALE } from "../foundations/interaction.js";

/**
 * Button looks, usable on a link (`<a className={buttonStyles({ variant })}>`) so navigation
 * stays a link while looking like a button.
 */
export const buttonStyles = tv({
  base: [
    "relative inline-flex shrink-0 cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-control font-body label-case",
    "data-disabled:cursor-default aria-busy:cursor-progress",
    PRESS,
    PRESS_SCALE,
    FOCUS_RING,
  ],
  variants: {
    variant: {
      /** The one money or core-loop action in a view: the brand gradient and its glow. */
      brand:
        "bg-[linear-gradient(135deg,var(--color-brand-start),var(--color-brand-end))] text-text-on-accent shadow-glow-brand not-data-disabled:hover:bg-[linear-gradient(0deg,var(--color-state-hover),var(--color-state-hover)),linear-gradient(135deg,var(--color-brand-start),var(--color-brand-end))] not-data-disabled:active:bg-[linear-gradient(0deg,var(--color-state-pressed),var(--color-state-pressed)),linear-gradient(135deg,var(--color-brand-start),var(--color-brand-end))] data-disabled:opacity-40 data-disabled:shadow-none",
      /** A solid commit action: Deposit, Join, Save. */
      primary:
        "bg-accent-default text-text-on-accent not-data-disabled:hover:bg-accent-hover not-data-disabled:active:bg-accent-pressed data-disabled:opacity-40",
      /** A neutral filled action beside a primary one. */
      secondary:
        "border border-secondary-edge bg-secondary-fill text-text-primary not-data-disabled:hover:bg-control-hover not-data-disabled:active:bg-bg-pressed data-disabled:border-border-subtle data-disabled:bg-bg-surface data-disabled:text-text-disabled",
      /** A quieter alternative with only an edge. */
      outline:
        "border border-border-strong text-text-secondary not-data-disabled:hover:bg-bg-hover not-data-disabled:hover:text-text-primary not-data-disabled:active:bg-bg-pressed data-disabled:border-border-subtle data-disabled:text-text-disabled",
      /** The lowest-emphasis action: Cancel, Skip. */
      ghost:
        "text-text-secondary not-data-disabled:hover:bg-bg-hover not-data-disabled:hover:text-text-primary not-data-disabled:active:bg-bg-pressed data-disabled:text-text-disabled",
      /** A secondary action floating over a stage or art. */
      glass:
        "glass text-text-primary not-data-disabled:hover:bg-[linear-gradient(0deg,var(--color-state-hover),var(--color-state-hover))] data-disabled:text-text-disabled",
      /** An action that destroys or can't be undone. */
      danger:
        "bg-status-danger text-text-on-danger not-data-disabled:hover:bg-[linear-gradient(0deg,var(--color-state-hover),var(--color-state-hover))] not-data-disabled:active:bg-[linear-gradient(0deg,var(--color-state-pressed),var(--color-state-pressed))] data-disabled:opacity-40",
    },
    size: {
      sm: "h-control-sm px-3 text-body-b2-strong",
      md: "h-control-md px-4 text-body-b1-strong",
      lg: "h-control-lg px-6 text-body-b1-strong",
    },
    fullWidth: { true: "w-full" },
  },
  defaultVariants: { variant: "primary", size: "md" },
});
